module.exports = __webpack_public_path__ + "static/media/dna.701c38d5.svg";